export default __webpack_public_path__ + "static/media/any-item.41b970b5.svg";